import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { postItemStrings } from '@/constants/residents/marketplaceStrings';
import { SVG_COMPONENTS } from '@/assets/admin';
import { postItemStyles } from './shared';

const LargeSuccessIcon = SVG_COMPONENTS.LARGE_SUCCESS;

export const StepSuccess: React.FC = () => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <View style={[postItemStyles.container, styles.container]}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <LargeSuccessIcon width={100} height={100} />
        </View>

        <View style={styles.textContainer}>
          <Text style={[styles.title, { color: MARKETPLACE_COLORS.textPrimary }]}>{postItemStrings.itemPublished}</Text>
          <Text style={[styles.subtitle, { color: MARKETPLACE_COLORS.textMuted }]}>
            {postItemStrings.itemPublishedSubtitle}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    paddingVertical: 44,
  },
  content: {
    alignItems: 'center',
    gap: 10,
  },
  iconContainer: {
    marginBottom: 10,
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 36,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24,
    textAlign: 'center',
  },
});
